attribute vec4 tangent;
varying vec2 vUv;
varying vec3 vWorldPos;
varying vec3 vPosition;
varying mat3 vTbn;

void main(){
    vUv=uv;
    vec4 worldPos4=modelMatrix*vec4(position,1.);
    vWorldPos=worldPos4.xyz;
    vPosition=(modelMatrix*vec4(position,1.)).xyz-cameraPosition;
    
    vec3 t=normalize(mat3(modelMatrix)*tangent.xyz);
    vec3 n=normalize(mat3(modelMatrix)*normal);
    vec3 b=normalize(cross(t,n));
    vTbn=mat3(t,b,n);
    gl_Position=projectionMatrix*modelViewMatrix*vec4(position,1.);
}